module.exports = __webpack_public_path__ + "static/img/5.483b079.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/5.png
// module id = gMJM
// module chunks = 0